import { Heading, ListItem } from '@athena/forge';
import ProxyButton from '../common/ProxyButton';
import SuccessLarge from '@athena/forge-icons/dist/SuccessLarge';

export interface EnrollItemProps {
  oktaFactorItem: JQuery;
  factorLabel: string;
  factorDescription: string;
  lastItem: boolean;
  isEnrolledFactor: boolean;
  oktaButton: JQuery;
}

export default function EnrollItem({
  factorLabel,
  factorDescription,
  oktaButton,
  oktaFactorItem,
  isEnrolledFactor,
  lastItem,
}: Readonly<EnrollItemProps>) {
  return (
    <ListItem className={`fe_u_flex-container ${lastItem ? 'fe_u_margin--bottom-small' : 'fe_u_margin--bottom-large'}`}>
      <div className={oktaFactorItem.attr('class')}>
        <div className={`${oktaFactorItem.children().attr('class')} fe_u_margin--right-medium`}>
          <div className={oktaFactorItem.find('.factor-icon').attr('class')}></div>
        </div>
      </div>
      <div>
        {isEnrolledFactor ? (
          <Heading className="fe_u_font-size--default" text={factorLabel} variant="subsection" />
        ) : (
          <Heading
            className="fe_u_font-size--default"
            text={factorLabel}
            variant="subsection"
            headingDescription={factorDescription}
          />
        )}
        <ProxyButton
          oktaButton={oktaButton}
          fullWidth={false}
          size="small"
          variant="secondary"
        />
      </div>
      {isEnrolledFactor && (
        <div style={{ position: 'absolute', right: 0 }}>
          <SuccessLarge />
        </div>
      )}
    </ListItem>
  );
}
